import React from 'react'
import { ReactComponent as Logo } from '../../assets/icons/logo.svg'
import { Link } from '../../utils/helpers'
import { footerPages } from '../../pages'
import { FormattedMessage } from 'react-intl'
import { Layout } from '../../utils/constants'
import Separator from '../../components/Separator'
import BackToTop from './components/BackToTop'

function Footer() {
    return (
        <footer className='footer side-padding md:px-[68px] pb-14 pt-10 md:pt-[88px] border-t border-black/10 bg-white'>
            <div className='flex flex-col md:flex-row gap-x-5 gap-y-10 justify-between md:pt-12'>
                <div>
                    <Logo className='fill-purple' />
                    <div className='flex flex-col pt-6 text-xs gap-y-1 opacity-80'>
                        <a href='mailto:hello@biomatter.com'>
                            <p>hello@biomatter.com</p>
                        </a>
                        <p>Rinktines str. 5-101, Vilnius</p>
                        <p>LT-09234, Lithuania</p>
                    </div>
                </div>
                <div className='grid grid-cols-2 md:grid-cols-3 md:gap-x-5 xl:gap-x-24 gap-y-10 gap-x-2'>
                    {footerPages.map((section) => (
                        <div key={section.title}>
                            <FormattedMessage id={section.title}>
                                {(value) => <span className='footer-link'>{value}</span>}
                            </FormattedMessage>
                            <div className='flex flex-col opacity-60 gap-y-3 mt-3'>
                                {section.pages.map((page) => (
                                    <Link
                                        to={page.path}
                                        key={page.title}
                                        className='opacity-60 hover:opacity-100 transition'
                                        external={page.external}
                                    >
                                        <FormattedMessage id={page.title} />
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                    <BackToTop className='md:hidden block' />
                </div>
                <BackToTop className='md:block hidden' />
            </div>
            <Separator className='my-10 hidden md:block' />
            <div className='flex flex-col-reverse md:flex-row md:items-stretch h-full opacity-60 text-xs pt-10 md:pt-0'>
                <div>
                    <p className='text-xs'>© 2026 BIOMATTER INC. ALL RIGHTS RESERVED.</p>
                </div>
                <Separator className='my-6 md:hidden' direction={Layout.HORIZONTAL} />
                <Separator className='hidden md:block mx-5' direction={Layout.VERTICAL} />

                <Link to='/privacy' className='md:self-center'>
                    <FormattedMessage id={'page.privacy'}>
                        {(value) => <p className='text-xs'>{value}</p>}
                    </FormattedMessage>
                </Link>
            </div>
        </footer>
    )
}
export default Footer
